// src/redux/actions/projetActions.js

export const FETCH_MY_PROJETS_REQUEST = "FETCH_MY_PROJETS_REQUEST";
export const FETCH_MY_PROJETS_SUCCESS = "FETCH_MY_PROJETS_SUCCESS";
export const FETCH_MY_PROJETS_FAIL    = "FETCH_MY_PROJETS_FAIL";

export const FETCH_ALL_PROJETS_REQUEST = "FETCH_ALL_PROJETS_REQUEST";
export const FETCH_ALL_PROJETS_SUCCESS = "FETCH_ALL_PROJETS_SUCCESS";
export const FETCH_ALL_PROJETS_FAIL    = "FETCH_ALL_PROJETS_FAIL";

export const CREATE_PROJET_REQUEST = "CREATE_PROJET_REQUEST";
export const CREATE_PROJET_SUCCESS = "CREATE_PROJET_SUCCESS";
export const CREATE_PROJET_FAIL    = "CREATE_PROJET_FAIL";

export const UPDATE_PROJET_REQUEST = "UPDATE_PROJET_REQUEST";
export const UPDATE_PROJET_SUCCESS = "UPDATE_PROJET_SUCCESS";
export const UPDATE_PROJET_FAIL    = "UPDATE_PROJET_FAIL";

export const DELETE_PROJET_REQUEST = "DELETE_PROJET_REQUEST";
export const DELETE_PROJET_SUCCESS = "DELETE_PROJET_SUCCESS";
export const DELETE_PROJET_FAIL    = "DELETE_PROJET_FAIL";

export const fetchMyProjetsRequest = () => ({ type: FETCH_MY_PROJETS_REQUEST });
export const fetchMyProjetsSuccess = (projets) => ({ type: FETCH_MY_PROJETS_SUCCESS, payload: projets });
export const fetchMyProjetsFail    = (error) => ({ type: FETCH_MY_PROJETS_FAIL, payload: error });

export const fetchAllProjetsRequest = () => ({ type: FETCH_ALL_PROJETS_REQUEST });
export const fetchAllProjetsSuccess = (projets) => ({ type: FETCH_ALL_PROJETS_SUCCESS, payload: projets });
export const fetchAllProjetsFail    = (error) => ({ type: FETCH_ALL_PROJETS_FAIL, payload: error });

export const createProjetRequest = (data) => ({ type: CREATE_PROJET_REQUEST, payload: data });
export const createProjetSuccess = (projet) => ({ type: CREATE_PROJET_SUCCESS, payload: projet });
export const createProjetFail    = (error) => ({ type: CREATE_PROJET_FAIL, payload: error });

export const updateProjetRequest = (id, data) => ({ type: UPDATE_PROJET_REQUEST, payload: { id, data } });
export const updateProjetSuccess = (projet) => ({ type: UPDATE_PROJET_SUCCESS, payload: projet });
export const updateProjetFail    = (error) => ({ type: UPDATE_PROJET_FAIL, payload: error });

export const deleteProjetRequest = (id) => ({ type: DELETE_PROJET_REQUEST, payload: id });
export const deleteProjetSuccess = (id) => ({ type: DELETE_PROJET_SUCCESS, payload: id });
export const deleteProjetFail    = (error) => ({ type: DELETE_PROJET_FAIL, payload: error });

